module.exports = __webpack_public_path__ + "static/media/authentication.328f8ada.svg";